import { Link } from '@inertiajs/react';
import { LocationPin } from '../../components/LocationPin';

export function TopNavigationLink({ href, children }: { href: string; children: React.ReactNode }) {
    return (
        <Link
            href={href}
            className='rounded-md px-3 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring'
        >
            {children}
        </Link>
    );
}

export function TopNavigationMenuButton({
    children,
    onClick,
    href,
    className,
}: {
    children: React.ReactNode;
    onClick?: () => void;
    href?: string;
    className?: string;
}) {
    const classes =
        'inline-flex items-center rounded-md px-1 py-1 transition duration-150 ease-in-out focus:outline-none focus:ring ' +
        className;

    if (href) {
        return (
            <Link href={href} onClick={onClick} className={classes}>
                {children}
            </Link>
        );
    }
    return (
        <button onClick={onClick} type='button' className={classes}>
            {children}
        </button>
    );
}

export function TopNavigationBar({
    mobileNavMenu,
    left,
    right,
    center,
}: {
    mobileNavMenu?: React.ReactNode;
    left: React.ReactNode;
    right: React.ReactNode;
    center?: React.ReactNode;
}) {
    return (
        <nav className='border-b-2 border-b-red-300 bg-white'>
            <div className='mx-auto max-w-6xl px-4'>
                <div className='flex h-16 items-center justify-between gap-4'>
                    <div className='flex items-center gap-8'>
                        <div className='flex items-center'>
                            <Link
                                href={route('index')}
                                className='rounded-md px-1 py-1 transition duration-150 ease-in-out focus:outline-none focus:ring'
                            >
                                <div className='flex items-center gap-2'>
                                    <div className='size-6'>
                                        <LocationPin />
                                    </div>
                                    <h1 className='hidden text-lg font-semibold text-gray-800 desktop:block'>
                                        AdventureList
                                    </h1>
                                </div>
                            </Link>
                        </div>
                        <div className='hidden desktop:flex desktop:items-baseline desktop:gap-2'>{left}</div>
                    </div>

                    <div className='flex w-full items-center justify-center'>{center}</div>

                    <div className='flex items-center gap-2'>{right}</div>
                </div>
            </div>
            {mobileNavMenu}
        </nav>
    );
}
